import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig, refineHeader } from "../../config";
import auth from "../auth";

export const siteService = {
	getCountry,
	get_site_details,
	update_site,
	getDashobardData,
	getCustomerData,
	checkSiteStatus,
	formSetting,
	saveBecomeForm,
	getLookupData,
	getApiSetting,
	saveApiSetting,
	getSeoSetting,
	saveSeoSetting,
	getAddRole,
	saveAddRole,
	roleList,
	roleStatus,
	installssl,
	updateAccountSettings
};

function getLookupData(formData, lookupType) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		body: JSON.stringify(formData)
	};
	return fetch(`${appConfig.api.url}lookup/${lookupType}`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}

function getCustomerData(formData) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		body: JSON.stringify(formData)
	};
	return fetch(`${appConfig.api.url}superadmin/search`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}

function getDashobardData(formData) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		body: JSON.stringify(formData)
	};
	return fetch(`${appConfig.api.url}superadmin/dashboard`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}

function getCountry() {
	const requestOptions = {
		method: "GET",
		headers: authHeader()
	};

	return fetch(`${config.apiUrl}city/country`, requestOptions).then(
		handleResponse
	);
}

function get_site_details(siteID) {
	refineHeader();
	const requestOptions = {
		method: "GET",
		headers: headerConfig.headerDatas,
		mode: "cors",
		// body: JSON.stringify()
	};

	return fetch(
		`${appConfig.api.url}site/detail/${siteID}`,
		requestOptions
	)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}

function checkSiteStatus(postData) {
	refineHeader();
	
	/*start-akash-rai-16-03-2022*/
	let id;
	let finalId;
	let currentUrl = window.location.href;
	let afterLastSlash = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
	let afterLastSlash1 = currentUrl.substring(currentUrl.lastIndexOf('/'));
	let urlObj = new URL(currentUrl);
         // Get the pathname from the URL object
        let pathname = urlObj.pathname;

// Split the pathname into segments
     let segments = pathname.split('/').filter(segment => segment.length > 0);

// Get the first segment
      let firstSegment = segments[0];
 //alert("whole url"+window.location.href);
	///
	//alert('afterLastSlash'+afterLastSlash);
 if(postData == undefined || postData != "en" || postData != "fr" || afterLastSlash!="" && afterLastSlash!="preview" && (currentUrl.indexOf(afterLastSlash) > -1)){
	    //alert("s1");
		if(window.location.href.indexOf("store") > -1){
			finalId = "";
		}else if(afterLastSlash == "cart" || afterLastSlash == "checkout"){
			//alert("s2");
			finalId =  (postData) ? '/'+postData.trim() : '';
		}else{
		//alert(firstSegment);
			if(firstSegment === 'city-deal')
			{
			finalId =  '/'+afterLastSlash;
			}
			else if(firstSegment === 'deals-detail')
			{  
				finalId =  '/'+afterLastSlash;
			//	alert(finalId);
			}
			else
			{
				finalId="/";
			}
		}
	}else{
		//alert("s4");
		finalId =  (postData) ? '/'+postData.trim() : '';
	}

	//alert("finalId"+finalId);

	/*end-akash-rai-16-03-2022*/

	id = finalId;
	const requestOptions = {
		method: "GET",
		headers: headerConfig.headerDatas,
		mode: "cors",
		// body: JSON.stringify()
	};

	if(id== "/"){
		id="";
	}

	if(id.indexOf("/?") !== -1){
		id = id.replace("/?", "?");
	}

	return fetch(
		`${appConfig.api.url}site-url/status${id}`,
		requestOptions
	)
		.then(handleResponse)
		.then(responseData => {
			//alert(responseData.country.default_city);


			// if(responseData.data.reservedtime != localStorage.getItem("version")  || localStorage.getItem("version") === null || typeof localStorage.getItem("version") == "undefined")
			// {
	        //     localStorage.clear();
	        //     localStorage.setItem("version", responseData.data.reservedtime);
	        //  	localStorage.setItem("siteDDBStatus", JSON.stringify(responseData.data));
			// }
			localStorage.setItem("version", responseData.data.reservedtime);
			// //alert(responseData.data.default_city);
			 localStorage.setItem("siteDDBStatus", JSON.stringify(responseData.data));
			 localStorage.setItem("defaultCity", JSON.stringify(responseData.country.default_city));
			return responseData;
		});
}



function update_site(postData) {
	refineHeader();
	const requestOptions = {
		method: "PUT",
		headers: headerConfig.headerDatas,
		mode: "cors",
		body: JSON.stringify(postData)
	};

	return fetch(`${appConfig.api.url}site/edit`, requestOptions)
		.then(handleResponse)
		.then(responseData => { 
			let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
			siteData.multi_lang = postData.multi_lang;
			siteData.default_lang = postData.default_lang;
			localStorage.setItem("siteDDBStatus", JSON.stringify(siteData));
			return responseData;
		});
}

function formSetting(postData) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		mode: "cors",
		// body: JSON.stringify(postData)
	};

	return fetch(`${appConfig.api.url}${postData}`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}

function saveBecomeForm(postData, url) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		mode: "cors",
		body: JSON.stringify(postData)
	};

	return fetch(`${appConfig.api.url}${url}`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}

function getApiSetting(postData) {
	refineHeader();
	const requestOptions = {
		method: "GET",
		headers: headerConfig.headerDatas,
		mode: "cors",
		// body: JSON.stringify()
	};

	return fetch(
		`${appConfig.api.url}api-settings/detail`,
		requestOptions
	)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}

function saveApiSetting(postData) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		mode: "cors",
		body: JSON.stringify(postData)
	};

	return fetch(`${appConfig.api.url}api-settings/save`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}
function getSeoSetting(postData) {
	refineHeader();
	const requestOptions = {
		method: "GET",
		headers: headerConfig.headerDatas,
		mode: "cors",
		// body: JSON.stringify()
	};

	return fetch(
		`${appConfig.api.url}seo-settings/detail`,
		requestOptions
	)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}

function saveSeoSetting(postData) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		mode: "cors",
		body: JSON.stringify(postData)
	};

	return fetch(`${appConfig.api.url}seo-settings/save`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}
function getAddRole(postData) {
	refineHeader();
	const requestOptions = {
		method: "GET",
		headers: headerConfig.headerDatas,
		mode: "cors",
		// body: JSON.stringify()
	};

	return fetch(
		`${appConfig.api.url}user-role/detail/${postData}`,
		requestOptions
	)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}

function saveAddRole(postData, url) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		mode: "cors",
		body: JSON.stringify(postData)
	};

	return fetch(`${appConfig.api.url}${url}`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}
function roleList(postData) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		mode: "cors",
		body: JSON.stringify(postData)
	};

	return fetch(`${appConfig.api.url}user-role/list`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}
function roleStatus(postData) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		mode: "cors",
		body: JSON.stringify(postData)
	};

	return fetch(`${appConfig.api.url}user-role/status`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}
function installssl(formData) {
	refineHeader();
	const requestOptions = {
		method: "POST",
		headers: headerConfig.headerDatas,
		body: JSON.stringify(formData)
	};
	return fetch(`${appConfig.api.url}import-ssl`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}

function updateAccountSettings(formData) {
	refineHeader();
	const requestOptions = {
		method: "PUT",
		headers: headerConfig.headerDatas,
		mode: "cors",
		body: JSON.stringify(formData)
	};

	return fetch(`${appConfig.api.url}site/account-settings`, requestOptions)
		.then(handleResponse)
		.then(responseData => {
			return responseData;
		});
}


function handleResponse(response) {
	return response.text().then(text => {
		const data = text && JSON.parse(text);
		if (!response.ok) {
			if (response.status === 401) {
				logout();
				location.reload(true);
			}
			const error = (data && data.message) || response.statusText;
			return Promise.reject(error);
		}
		return data;
	});
}



// WEBPACK FOOTER //
// ./src/app/services/API/siteService.js